import React, { useState, useEffect, useRef } from 'react';

import ProgressBar from 'react-bootstrap/ProgressBar';

import axios from 'axios';

import Form from './Form';
import planilha from './planilha';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const COLUNA_VALOR_TARIFA = 'tarifaFinal';
const COLUNA_PARTICIPACAO_EMPREGADOR = 'empregador';
const COLUNA_IMPACTO = 'impacto';
const COLUNA_PA = 'pa';
const CHAVE_VALOR_INICIAL = '0000';
const CHAVE_VALOR_MAXIMO = '0000';
const CHAVE_IMPACTO_PL1 = '1000';
const CHAVE_IMPACTO_PL2 = '0100';
const CHAVE_IMPACTO_PL3 = '0010';
const CHAVE_IMPACTO_PL4 = '0001';

function App() {
	const marcaRef = useRef();
	const [yOffSet, setYOffSet] = useState(0);
	const [top, setTop] = useState(0);
	const [pl1, setPl1] = useState(false);
	const [pl2, setPl2] = useState(false);
	const [pl3, setPl3] = useState(false);
	const [pl4, setPl4] = useState(false);
	const [pl5, setPl5] = useState(false);
	const [key, setKey] = useState(CHAVE_VALOR_INICIAL);
	const [valor, setValor] = useState(0);
	const [valorEmpresario, setValorEmpresario] = useState(0);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const handleScroll = () => {
		if (marcaRef && marcaRef.current) {
			setTop(marcaRef.current.offsetTop);
			setYOffSet(window.pageYOffset);
		}
	};

	useEffect(() => {
		const p1 = pl1 ? '1' : '0';
		const p2 = pl2 ? '1' : '0';
		const p3 = pl3 ? '1' : '0';
		const p4 = pl4 ? '1' : '0';
		setKey(`${p1}${p2}${p3}${p4}`);
	}, [pl1, pl2, pl3, pl4, pl5]);

	useEffect(() => {
		setValor(pl5 ? planilha.find(p => p.id === key)[COLUNA_PA] : planilha.find(p => p.id === key)[COLUNA_VALOR_TARIFA]);
		setValorEmpresario(pl5 ? planilha.find(p => p.id === key)[COLUNA_PARTICIPACAO_EMPREGADOR] : 0);
	}, [key, pl5]);

	const format = valor => {
		let valorAsString = `${valor}`;
		valorAsString = valorAsString.replace('.', ',');
		if (valorAsString.indexOf(',') === -1) {
			valorAsString += ',00';
		}
		let [inteiro, decimal] = valorAsString.split(',');
		if (decimal.length === 1) {
			decimal += '0';
		}
		return `${inteiro},${decimal}`;
	};

	const onSubmit = identificacao => {
		const options = {
			method: 'post',
			url: `${API_URL}/api/respostas`,
			data: {
				...identificacao,
				pl1,
				pl2,
				pl3,
				pl4,
				pl5
			},
			headers: {},
			timeout: 0
		};
		axios(options);
	};

	return (
		<>
			<div
				className="marca-posicao"
				style={{
					height: '0px'
				}}
				ref={marcaRef}
			/>
			<div className={`progress-bar-container ${yOffSet > top ? 'sticky' : ''}`}>
				<span className="label-barra"> Minha tarifa </span>
				<ProgressBar
					variant="tarifa"
					now={valor}
					max={planilha.find(p => p.id === CHAVE_VALOR_MAXIMO)[COLUNA_VALOR_TARIFA]}
					label={format(valor)}
				/>
				<span className="label-barra"> Taxa de mobilidade urbana</span>
				<span className="label-barra-sub">(passe livre para o trabalhador formal)</span>
				<ProgressBar
					variant="empresario"
					now={valorEmpresario}
					max={planilha.find(p => p.id === CHAVE_VALOR_MAXIMO)[COLUNA_PARTICIPACAO_EMPREGADOR]}
					label={format(valorEmpresario)}
				/>
			</div>
			<div className="container">
				<div className="texto-apresentacao">
					<p className="titulo">
						Se você fosse votar a favor ou contra os Projetos de Lei propostos pela Prefeitura, quais seriam as suas
						escolhas?
					</p>
					<p>
						Acompanhe, nas barras acima, o impacto direto dessas escolhas no valor da tarifa de ônibus de Porto Alegre*.
					</p>
				</div>
				<div>
					<p className="titulo-pl"> 1 | FIM DA TAXA DA CCT </p>
					<p className="pergunta-pl">
						Nesta proposta, a Prefeitura deixaria de cobrar, embutida no valor da passagem, a CCT, taxa usada para
						custear a gestão do sistema de transporte.{' '}
						<a target="_blank" href="/simuladortarifa/projeto-transporte-cidadao#perg1">
							Saiba mais
						</a>
					</p>
				</div>

				<div className="form-item form-type-radio radio" onClick={() => setPl1(true)}>
					<input
						type="radio"
						value={false}
						name="pl1"
						id="pl1Sim"
						checked={pl1}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl1Sim">
						Sim, sou a favor do fim da taxa{' '}
						<span className="valor-a-reduzir">
							{' '}
							(-R$ {format(planilha.find(p => p.id === CHAVE_IMPACTO_PL1)[COLUNA_IMPACTO])}){' '}
						</span>
					</label>
				</div>

				<div className="form-item form-type-radio radio" onClick={() => setPl1(false)}>
					<input
						type="radio"
						value={false}
						name="pl1"
						checked={!pl1}
						onChange={() => false}
						id="pl1Nao"
						className="form-radio"
					/>
					<label htmlFor="pl1Nao">Não, acho que a taxa deve continuar a ser cobrada</label>
				</div>
				<div>
					<p className="titulo-pl"> 2 | TARIFA DE USO DO SISTEMA VIÁRIO </p>
					<p className="pergunta-pl">
						Aplicar uma tarifa de R$ 0,28 por km rodado para as empresas de transporte por aplicativos (Uber, Cabify,
						99, Garupa, etc.), pelo uso do sistema viário.{' '}
						<a target="_blank" href="/simuladortarifa/projeto-transporte-cidadao#perg2">
							Saiba mais
						</a>
					</p>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl2(true)}>
					<input
						type="radio"
						value={false}
						name="pl2"
						id="pl2Sim"
						checked={pl2}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl2Sim">
						Sim, sou a favor de cobrança desta tarifa{' '}
						<span className="valor-a-reduzir">
							{' '}
							(-R$ {format(planilha.find(p => p.id === CHAVE_IMPACTO_PL2)[COLUNA_IMPACTO])}){' '}
						</span>
					</label>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl2(false)}>
					<input
						type="radio"
						value={false}
						name="pl2"
						id="pl2Nao"
						checked={!pl2}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl2Nao">Não, sou contra a cobrança desta tarifa</label>
				</div>
				<div>
					<p className="titulo-pl"> 3 | TARIFA DE CONGESTIONAMENTO </p>
					<p className="pergunta-pl">
						Veículos emplacados fora de Porto Alegre pagam uma tarifa de ônibus para entrar no município.{' '}
						<a target="_blank" href="/simuladortarifa/projeto-transporte-cidadao#perg3">
							Saiba mais
						</a>
					</p>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl3(true)}>
					<input
						type="radio"
						value={false}
						name="pl3"
						id="pl3Sim"
						checked={pl3}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl3Sim">
						Sim, sou a favor desta cobrança{' '}
						<span className="valor-a-reduzir">
							{' '}
							(-R$ {format(planilha.find(p => p.id === CHAVE_IMPACTO_PL3)[COLUNA_IMPACTO])}){' '}
						</span>
					</label>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl3(false)}>
					<input
						type="radio"
						value={false}
						name="pl3"
						id="pl3Nao"
						checked={!pl3}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl3Nao">Não, sou contra esta cobrança</label>
				</div>
				<div>
					<p className="titulo-pl">
						{' '}
						4 | REDUÇÃO GRADUAL DE COBRADORES <label className="alerta-rejeitado">Projeto rejeitado pela Câmara de Vereadores</label>{' '}
					</p>
					<p className="pergunta-pl">
						Flexibilização da lei de tripulação dos ônibus, que obriga que cada ônibus tenha um cobrador, mesmo em
						horários de menor fluxo e em dias de passe livre (sem demissão dos cobradores).{' '}
						<a target="_blank" href="/simuladortarifa/projeto-transporte-cidadao#perg4">
							Saiba mais
						</a>
					</p>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl4(true)}>
					<input
						type="radio"
						value={false}
						name="pl4"
						id="pl4Sim"
						checked={pl4}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl4Sim">
						Sim, acho dispensável a exigência de um cobrador por ônibus{' '}
						<span className="valor-a-reduzir">
							{' '}
							(-R$ {format(planilha.find(p => p.id === CHAVE_IMPACTO_PL4)[COLUNA_IMPACTO])}){' '}
						</span>
					</label>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl4(false)}>
					<input
						type="radio"
						value={false}
						name="pl4"
						id="pl4Nao"
						checked={!pl4}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl4Nao">Não, acho imprescindível a presença do cobrador, em todos os casos</label>
				</div>
				<div>
					<p className="titulo-pl"> 5 | TAXA DE MOBILIDADE URBANA </p>
					<p className="pergunta-pl">
						A TMU é um encargo urbano cobrado das empresas por empregado com carteira assinada, o que garante para estes
						trabalhadores o <span class="destaque-texto">passe livre</span> no sistema de transporte coletivo. Como este encargo ajuda a subsidiar a
						passagem, o valor da tarifa baixa para todos os usuários.{' '}
						<a target="_blank" href="/simuladortarifa/projeto-transporte-cidadao#perg6">
							Saiba mais
						</a>
					</p>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl5(true)}>
					<input
						type="radio"
						value={false}
						name="pl5"
						id="pl5Sim"
						checked={pl5}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl5Sim">Sim, sou a favor da cobrança da TMU</label>
				</div>
				<div className="form-item form-type-radio radio" onClick={() => setPl5(false)}>
					<input
						type="radio"
						value={false}
						name="pl5"
						id="pl5Nao"
						checked={!pl5}
						onChange={() => false}
						className="form-radio"
					/>
					<label htmlFor="pl5Nao">Não, sou contra a cobrança da TMU</label>
				</div>
				<div className="observacao">
					*Os valores presentes na simulação contêm estimativas que podem variar até a implementação definitiva de cada
					medida, pois levam em conta índices atuais.
				</div>
				<div className="resultados-questionario">
					<p className="titulo-valores"> Resultado das suas opções </p>
					<p className="subtitulo-valores">
						<strong>Projeção da tarifa com base nos valores atuais,</strong> caso a aprovação dos Projetos de Lei se dê em conformidade com o que você
						escolheu, no questionário acima:
					</p>
					<div className="grid-valores">
						<div className="item-valor">
							<span className="label-valores-rs">
								Tarifa vigente <br />
								(atual)
							</span>
							<span className="valores-rs vigente"> R$ 4,70 </span>
						</div>
						<div className="item-valor">
							<span className="label-valores-rs">
								Minha tarifa projetada 2019 <br />
								(sem taxa de mobilidade urbana)
							</span>
							<span className="valores-rs projetada-2020-sem">
								R$ {format(planilha.find(p => p.id === key)[COLUNA_VALOR_TARIFA])}
							</span>
						</div>
						<div className="item-valor">
							<span className="label-valores-rs">
								Minha tarifa projetada 2021 <br />
								(com taxa de mobilidade urbana)
							</span>
							<span className="valores-rs projetada-2020-com">
								R$ {format(planilha.find(p => p.id === key)[COLUNA_PA])}
							</span>
						</div>
					</div>
				</div>
				<Form onSubmit={onSubmit} />
			</div>
		</>
	);
}
App.displayName = 'App';

export default App;
